var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VerifyPhoneStep2',{ref:"ChangePhoneDia",attrs:{"showChangePhoneFlag":_vm.showChangePhoneFlag},on:{"handleClose":function($event){_vm.showChangePhoneFlag = false},"goNext":_vm.goNext}}),_c('VerifyPhone',{attrs:{"isShow":_vm.isShow,"verifyData":_vm.verifyData},on:{"handleClose":_vm.handleClose,"confirm":_vm.confirm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }